import React from "react";
import Container from "../../components/container";
import useLogged from "../../hooks/useLogged";

const MainLayout = ({ children }) => {
  useLogged();

  return <Container>{children}</Container>;
};

export default MainLayout;
